import React, { useState, useEffect } from 'react';
import Header from "../Componentes/Header";
import Menu from "../Componentes/Menu";
import Footer from "../Componentes/Footer";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export default function InclusionDeportiva() {

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Cambia 768 por la resolución deseada
        };

        // Agrega un event listener para detectar cambios en el tamaño de la pantalla
        window.addEventListener('resize', handleResize);
        handleResize(); // Llama a la función para verificar el tamaño inicial

        // Limpia el event listener cuando el componente se desmonta
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            <Header></Header>
            <Menu></Menu>

            <div className="container-inclusion" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
                <h1>Inclusión Deportiva de Alto Rendimiento</h1>
                
                <h3>Tu pasión por el deporte. Tu educación. Tu futuro.</h3>
                
                <p><strong>No tienes que elegir</strong> entre perseguir tus sueños deportivos y construir tu futuro académico.</p>
                
                <p>En Britannia School creemos que el talento necesita oportunidades y que una gran meta deportiva no debe significar renunciar a una educación de calidad.</p>
                
                <p>Sabemos que detrás de cada deportista hay horas de entrenamiento, disciplina, sacrificios y competencias que exigen dedicación y compromiso. Por eso, nuestro modelo de educación personalizada busca adaptarse a las necesidades de cada estudiante, brindándole acompañamiento y flexibilidad para avanzar en su formación académica mientras desarrolla su potencial deportivo.</p>
                
                <p>Queremos que nuestros estudiantes puedan competir, superar sus propios límites y perseguir sus metas, sin dejar de prepararse para todas las oportunidades que les esperan dentro y fuera del deporte.</p>
                
                <p>En Britannia School, impulsamos tu talento deportivo mientras construyes las bases de tu futuro.</p>
                
                <p>Porque los sueños más grandes merecen una educación que avance contigo.</p>
                
                <p><strong>Tu talento no tiene que elegir. Tu futuro puede llegar más lejos.</strong></p>

                {/* Contenedor de las imágenes */}
                <div className="imagenes-futuro" style={{ display: 'flex', gap: '20px', justifyContent: 'center', margin: '30px 0', flexWrap: 'wrap' }}>
                    <img 
                        src="https://britanniaschool.co.com/imagenes/futuro1.jpeg" 
                        alt="Inclusión Deportiva Britannia School 1" 
                        style={{ maxWidth: '100%', height: 'auto', width: '350px', borderRadius: '8px' }} 
                    />
                    <img 
                        src="https://britanniaschool.co.com/imagenes/futuro2.jpeg" 
                        alt="Inclusión Deportiva Britannia School 2" 
                        style={{ maxWidth: '100%', height: 'auto', width: '350px', borderRadius: '8px' }} 
                    />
                </div>
            </div>

            <br></br>
            <a href='#' className='volver'>Volver</a>
            <br></br><br></br>

            <Footer></Footer>
        </div>
    );
}